import React from 'react';
import TopNavigation from '../components/TopNavigation';

const Help: React.FC = () => {
  return (
    <div style={styles.container}>
      <TopNavigation />
      <div style={styles.contentArea}>
        <header style={styles.header}>
          <h1 style={styles.title}>Help Center</h1>
          <p style={styles.subtitle}>Get answers to common questions and learn how to use Belivah.</p>
        </header>

        <section style={styles.section}>
          <h2 style={styles.h2}>Frequently Asked Questions</h2>
          <ul style={styles.ul}>
            <li><strong>How do I share a testimony?</strong> Go to Testimony, click "+ Share", add your story/video, and submit.</li>
            <li><strong>How long can videos be?</strong> Testimonies: up to 5 minutes. Pulse: up to 2 minutes.</li>
            <li><strong>How do I report content?</strong> Use the report menu on any post or contact us via the in-app Help link.</li>
            <li><strong>How do I manage privacy?</strong> Visit Settings to update your profile, privacy, and notifications.</li>
          </ul>
        </section>

        <section style={styles.section}>
          <h2 style={styles.h2}>Contact Support</h2>
          <p style={styles.p}>If you need help, please reach out: support@belivah.com</p>
        </section>
      </div>
    </div>
  );
};

const styles: { [k: string]: React.CSSProperties } = {
  container: { display: 'flex', flexDirection: 'column', minHeight: '100vh', background: 'var(--color-background-alt)' },
  contentArea: { maxWidth: '900px', margin: '0 auto', padding: '84px 16px 24px', width: '100%', boxSizing: 'border-box' },
  header: { background: '#0B6B6F', color: '#fff', padding: '20px 24px', borderRadius: 12 },
  title: { margin: 0, fontSize: 28 },
  subtitle: { margin: '6px 0 0 0', fontSize: 14 },
  section: { background: '#fff', borderRadius: 12, padding: 20, marginTop: 16, border: '1px solid var(--color-border)' },
  h2: { margin: '0 0 10px 0', color: '#072B2C', fontSize: 20 },
  p: { margin: 0, color: '#072B2C' },
  ul: { margin: '0 0 0 18px', color: '#072B2C' },
};

export default Help;
